module.exports = __webpack_public_path__ + "media/images/instagram-81c49f92565f47164a7cef3566db6504.svg";